import React from "react";

const DeleteUser = () => {
  return <div></div>;
};

export { DeleteUser };
